(function () {
  if (customElements.get('gs-reformer-savings')) return;
  customElements.define('gs-reformer-savings', class extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      this.locale = this.dataset.locale || document.documentElement.lang || 'en-GB';
      this.copy = (key, values = {}) => {
        const message = this.dataset['copy' + key.split('_').map(part => part[0].toUpperCase() + part.slice(1)).join('')] || '';
        return message.replace(/\[([a-z]+)\]/g, (match, name) => String(values[name] ?? match));
      };
      this.listeners = new AbortController();
      const { signal } = this.listeners;
      this.period = 'week'; this.years = 1;
      this.price = Number(this.dataset.price) / 100;
      this.currency = this.dataset.currency || 'GBP';
      this.$ = selector => this.querySelector(selector);
      this.put = (selector, text) => { this.$(selector).textContent = text; };
      this.money = (value, digits = 0) => new Intl.NumberFormat(this.locale, {style:'currency', currency:this.currency, minimumFractionDigits:digits, maximumFractionDigits:digits}).format(value);
      const symbol = new Intl.NumberFormat(this.locale,{style:'currency',currency:this.currency}).formatToParts(1).find(p => p.type === 'currency').value;
      this.put('[data-symbol]',symbol); this.put('[data-currency-label]',this.currency);
      this.addEventListener('input', event => {
        if (event.target.matches('[data-range]')) this.$('[data-frequency]').value = event.target.value;
        if (event.target.matches('input')) this.update();
      }, { signal });
      this.addEventListener('click', event => {
        const button = event.target.closest('button');
        if (!button) return;
        if (button.dataset.period) {
          this.period = button.dataset.period;
          this.querySelectorAll('[data-period]').forEach(b => b.setAttribute('aria-pressed',String(b === button)));
          this.put('[data-period-label]',this.copy(this.period === 'week' ? 'classes_week' : 'classes_month'));
          this.$('[data-range]').setAttribute('aria-label',this.copy(this.period === 'week' ? 'range_week' : 'range_month'));
        }
        if (button.dataset.step) {
          const field = this.$('[data-frequency]');
          field.value = Math.max(1, Math.min(60, (Number(field.value) || 1) + Number(button.dataset.step)));
        }
        if (button.dataset.years) {
          this.years = Number(button.dataset.years);
          this.querySelectorAll('[data-years]').forEach(b => b.setAttribute('aria-pressed',String(b === button)));
        }
        this.update();
      }, { signal });
      this.$('[data-back]').addEventListener('click', event => {
        const forms = Array.from(document.querySelectorAll('form[action*="/cart/add"]'));
        const form = forms.find(f => f.querySelector('[name="product-id"]')?.value === this.dataset.productId && f.querySelector('[name="add"]') && f.getClientRects().length);
        const target = form?.querySelector('[name="add"]');
        if (!target) return; // Normal link is a safe fallback if the theme markup changes.
        event.preventDefault();
        let offset = 24;
        document.querySelectorAll('sticky-header, .shopify-section-header-sticky, header').forEach(header => {
          const rect = header.getBoundingClientRect();
          if (['sticky','fixed'].includes(getComputedStyle(header).position) && rect.bottom > 0 && rect.top <= 1) offset = Math.max(offset,rect.bottom+24);
        });
        const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        window.scrollTo({top:Math.max(0, target.getBoundingClientRect().top + window.scrollY - offset - 80), behavior:reduced?'instant':'smooth'});
        target.focus({preventScroll:true});
      }, { signal });
      this.$('[data-reviews]').addEventListener('click', event => {
        const target = document.getElementById('judgeme_product_reviews') || document.querySelector('.jdgm-review-widget');
        if (!target) return;
        event.preventDefault();
        const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        let offset = 24;
        document.querySelectorAll('sticky-header, .shopify-section-header-sticky, header').forEach(header => {
          const rect = header.getBoundingClientRect();
          if (['sticky','fixed'].includes(getComputedStyle(header).position) && rect.bottom > 0 && rect.top <= 1) offset = Math.max(offset,rect.bottom+24);
        });
        window.scrollTo({top:Math.max(0,target.getBoundingClientRect().top+window.scrollY-offset),behavior:reduced?'instant':'smooth'});
        if (!target.hasAttribute('tabindex')) target.setAttribute('tabindex','-1');
        target.focus({preventScroll:true});
      }, { signal });
      this.update();
      // Liquid gives the current price immediately; Ajax refreshes that same exact variant.
      const root = window.Shopify?.routes?.root || '/';
      this.refreshPrice(root, signal);
    }
    disconnectedCallback() {
      this.listeners?.abort();
      this._ready = false;
    }
    async refreshPrice(root, signal) {
      try {
        const response = await fetch(root + 'products/gymsets-reformer-pilates-machine.js', {
          headers: { Accept: 'application/json' }, signal
        });
        if (!response.ok) throw new Error('Price request failed: ' + response.status);
        const product = await response.json();
        const variant = product.variants.find(item => String(item.id) === '55974132515189');
        if (!variant || !Number.isFinite(Number(variant.price)) || Number(variant.price) <= 0) {
          throw new Error('Reformer variant price is unavailable');
        }
        this.price = Number(variant.price) / 100;
        this.dataset.productId = String(product.id);
        this.update();
      } catch (error) {
        if (error.name === 'AbortError') return;
        console.warn('Reformer savings calculator: unable to refresh price; retaining Liquid price.', error);
        this.update();
      }
    }
    update() {
      const cost = Number(this.$('[data-class-price]').value);
      const frequency = Number(this.$('[data-frequency]').value);
      const validCost = Number.isFinite(cost) && cost > 0 && cost <= 10000;
      const validFrequency = Number.isInteger(frequency) && frequency >= 1 && frequency <= 60;
      this.$('[data-class-price]').setAttribute('aria-invalid',String(!validCost));
      this.$('[data-frequency]').setAttribute('aria-invalid',String(!validFrequency));
      const range = this.$('[data-range]');
      range.max = String(Math.max(this.period === 'week' ? 14 : 30, validFrequency ? frequency : 1));
      range.value = String(validFrequency ? frequency : 1);
      range.style.setProperty('--fill',((Number(range.value)-1)/(Number(range.max)-1)*100)+'%');
      this.put('[data-range-max]',this.copy('classes_count', { count: new Intl.NumberFormat(this.locale).format(Number(range.max)) }));
      this.put('[data-price-label]',this.price > 0 ? this.money(this.price,2) : this.copy('unavailable'));
      this.$('[data-output]').hidden = !(this.price > 0 && validCost && validFrequency);
      if (!(this.price > 0)) { this.put('[data-status]',this.copy('price_error')); this.put('[data-monthly]','—'); return; }
      if (!validCost || !validFrequency) { this.put('[data-status]',this.copy('input_error')); this.put('[data-monthly]','—'); return; }
      const annual = cost * frequency * (this.period === 'week' ? 52 : 12);
      const monthly = annual / 12;
      const months = this.price / monthly;
      const firstYear = annual - this.price;
      const studio = annual * this.years;
      const saving = studio - this.price;
      const monthsText = months < .1 ? '< ' + new Intl.NumberFormat(this.locale).format(0.1) : new Intl.NumberFormat(this.locale,{maximumFractionDigits:1}).format(Math.ceil(months*10)/10);
      this.put('[data-months]', monthsText);
      this.$('[data-months]').style.fontSize = monthsText.length > 6 ? '36px' : '';
      this.put('[data-months-unit]',this.copy(months === 1 ? 'month' : 'months'));
      this.put('[data-classes]',this.copy('equivalent', { count: Math.ceil(this.price/cost).toLocaleString(this.locale), price: this.money(cost,2) }));
      this.put('[data-monthly]',this.money(monthly,2));
      this.put('[data-net-label]',this.copy(firstYear >= 0 ? 'net_saving' : 'net_remaining'));
      this.put('[data-net]',this.money(Math.abs(firstYear),2));
      this.put('[data-annual]',this.money(annual,2));
      this.put('[data-studio-total]',this.money(studio,2));
      this.put('[data-home-total]',this.money(this.price,2));
      const max = Math.max(studio,this.price);
      this.$('[data-studio-bar]').style.width = (studio/max*100)+'%';
      this.$('[data-home-bar]').style.width = (this.price/max*100)+'%';
      const durationKey = this.years === 1 ? 'one' : 'many';
      const years = new Intl.NumberFormat(this.locale).format(this.years);
      this.put('[data-total-label]',this.copy((saving >= 0 ? 'saving_' : 'remaining_') + durationKey, { years }));
      this.put('[data-total]',this.money(Math.abs(saving),2));
      this.put('[data-status]','');
      // A concise screen-reader update without repeatedly announcing every figure.
      this.$('[data-output]').setAttribute('aria-label',this.copy((saving >= 0 ? 'summary_saving' : 'summary_remaining') + (this.years === 1 ? '_one' : ''), { months: monthsText, unit: this.copy(months === 1 ? 'month' : 'months'), amount: this.money(Math.abs(saving),2), years }));
    }
  });
})();
